import { apiPlugin, StoryblokVue } from '@storyblok/vue'
import { defineNuxtPlugin, useRuntimeConfig } from '#app'

export default defineNuxtPlugin(({ vueApp }) => {
  const { storyblok } = useRuntimeConfig().public

  vueApp.use(StoryblokVue, {
    ...storyblok,
    use: [apiPlugin],
  })
})
